import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/groups/{slug}/follow-ups/` redirects to the first subnav, Follow-up
 * Requests, as legacy does; without it the tab bar renders over an empty
 * outlet. The member tab has a real index screen instead.
 *
 * Done in `beforeLoad`, since no data is needed, so the empty tab body never
 * paints. Unlike legacy, only the bare slug redirects, not an unknown slug
 * under the tab.
 */
export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/follow-ups/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/groups/$groupName/follow-ups/follow-up-requests/',
      params: { groupName: params.groupName },
      replace: true,
    });
  },
});
